<template>
  <div class="header-box">
    <div class="header">
      <span class="colorspan">{{ titleName }}</span>
    </div>
    <div class="table-content">
      <table border="1">
        <tr>
          <th colspan="6" class="title">一、基本信息</th>
        </tr>
        <tr>
          <th>基地名称*</th>
          <td colspan="5"><input type="text" v-model="dataInfo.baseName" /></td>
        </tr>
        <tr>
          <th>申报入口*</th>
          <td colspan="5">
            <input type="text" v-model="dataInfo.decEntrance" readonly />
          </td>
        </tr>
        <tr>
          <th>基地负责人姓名*</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.responsor" />
          </td>
          <th>基地负责人联系方式*</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.responsorPhone" />
          </td>
        </tr>
        <tr>
          <th>基地联络人姓名*</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.contact" />
          </td>
          <th>基地联络人联系方式*</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.contactPhone" />
          </td>
        </tr>
        <tr>
          <th>基地地址*</th>
          <td colspan="5">
            <input type="text" v-model="dataInfo.baseAddress" />
          </td>
        </tr>
        <tr>
          <th>基地官网和网址（可填）</th>
          <td colspan="5">
            <input type="text" v-model="dataInfo.baseWebsite" />
          </td>
        </tr>
        <tr>
          <th>基地开放服务时间*</th>
          <td colspan="5">
            <input type="text" v-model="dataInfo.baseOpenServiceHours" />
          </td>
        </tr>
        <tr>
          <th>交通路线*</th>
          <td colspan="5">
            <input type="text" v-model="dataInfo.trafficRoutes" />
          </td>
        </tr>
        <tr>
          <th>VR虚拟场馆网址（可填）</th>
          <td colspan="5">
            <input type="text" v-model="dataInfo.vrWebsite" />
          </td>
        </tr>
        <tr>
          <th class="title" colspan="6" style="position: relative">
            二、基地简介*
          </th>
        </tr>
        <tr>
          <td colspan="6" style="padding: 20px;">
            <textarea cols="50" rows="11" maxlength="450" v-model="dataInfo.baseIntroduction" placeholder="基地的文字简介，450字以内"
              id="contactus" name="contactus"></textarea>
            <a-spin :spinning="baseImgSpinning" tip="上传中">
              <div>
                <a-upload name="baseImgUpload" style="margin-top: 10px;" accept="image/*" list-type="picture-card"
                  :file-list="baseImgFileList" :remove="e => imgDel(e, 1)" :before-upload="beforeUploadOfImg"
                  :customRequest="e => uploadImgFun(e, 1)">
                  <div v-if="baseImgFileList.length < 10">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">
                      上传图片
                    </div>
                  </div>
                </a-upload>
                <p style="margin-bottom: 20px;">请提供三-五幅基地照片，照片大小每幅2M以上。</p>
              </div>
            </a-spin>

            <a-spin :spinning="baseVideoSpinning" tip="上传中">
              <div>
                <a-upload name="videoUpload" :before-upload="beforeUploadOfVideo" accept="video/mp4"
                  :customRequest="e => uploadVideoFun(e, 1)" :showUploadList=false>
                  <a-button :disabled="baseVideoUrl.length == 1"> <a-icon type="upload" /> 上传视频 </a-button>
                </a-upload>
                <p style="margin-top: 10px;">提供基地宣传视频一个，视频格式为MP4，分辨率1920*1080，大小不超过200M。</p>
              </div>
              <div v-if="baseVideoUrl.length != 0" v-for="(vItem, index) in baseVideoUrl" :key="index" class="video-box">
                <img @click="removeVideo(index, 1)" src="@/assets/video/close.png" alt="">
                <video controls :src="vItem"></video>
              </div>
            </a-spin>
          </td>
        </tr>
        <tr>
          <th class="title" colspan="6" style="position: relative">
            三、特色普及活动介绍*
          </th>
        </tr>
        <tr>
          <td colspan="6" style="padding: 20px;">
            <textarea cols="50" rows="11" maxlength="450" v-model="dataInfo.activityIntroduction"
              placeholder="特色普及活动的文字简介，450字以内" id="contactus" name="contactus"></textarea>
            <a-spin :spinning="actImgSpinning" tip="上传中">
              <div>
                <a-upload name="imgUpload" style="margin-top: 10px;" accept="image/*" list-type="picture-card"
                  :file-list="actImgFileList" :remove="e => imgDel(e, 2)" :before-upload="beforeUploadOfImg"
                  :customRequest="e => uploadImgFun(e, 2)">
                  <div v-if="actImgFileList.length < 10">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">
                      上传图片
                    </div>
                  </div>
                </a-upload>
                <p style="margin-bottom: 20px;">请提供照片三-五幅特色普及活动图片，照片大小每幅2M以上。</p>
              </div>
            </a-spin>

            <a-spin :spinning="actVideoSpinning" tip="上传中">
              <div>
                <a-upload name="videoUpload" :before-upload="beforeUploadOfVideo" accept="video/mp4"
                  :customRequest="e => uploadVideoFun(e, 2)" :showUploadList=false>
                  <a-button :disabled="actVideoUrl.length == 1"> <a-icon type="upload" /> 上传视频 </a-button>
                </a-upload>
                <p style="margin-top: 10px;">提供基地年度的特色活动视频一个，视频格式为MP4，分辨率1920*1080，大小不超过200M。</p>
              </div>
              <div v-if="actVideoUrl.length != 0" v-for="(vItem, index) in actVideoUrl" :key="index" class="video-box">
                <img @click="removeVideo(index, 2)" src="@/assets/video/close.png" alt="">
                <video controls :src="vItem"></video>
              </div>
            </a-spin>
          </td>
        </tr>
      </table>
    </div>


    <div class="footer">
      <a-button v-if="(createUid == userId) || declareId == ''" type="primary"
        :disabled="baseVideoSpinning || actVideoSpinning || baseImgSpinning || actImgSpinning"
        @click="createPublicizeFun(0)">保存草稿</a-button>
      <a-button type="primary" :disabled="baseVideoSpinning || actVideoSpinning || baseImgSpinning || actImgSpinning"
        @click="createPublicizeFun(1)">{{
          (createUid == userId) || declareId == '' ? '提交' : '保存' }}</a-button>
      <a-button @click="cancel">返回</a-button>
    </div>
  </div>
</template>

<script>
import {
  createdecInformationApi,
  updateDecInformationApi,
  openUploadApi,
  openSplitUploadApi
} from "@/api/declare";
export default {
  props: {
    chooseType: {
      type: Number,
      default: 0,
    },
    toTarget: {
      type: String,
    },
  },
  data() {
    return {
      userTypeValue: "",
      userId: '',
      createUid: '',
      titleName: "基地信息填报",
      baseImgSpinning: false,
      baseVideoSpinning: false,
      actImgSpinning: false,
      actVideoSpinning: false,
      declareId: '',
      dataInfo: {
        baseName: "" /* 申报基地名称 */,
        responsor: "" /* 基地负责人 */,
        responsorPhone: "" /* 基地负责人手机 */,
        contact: "" /* 基地联系人 */,
        contactPhone: "" /* 基地联系人手机 */,
        baseAddress: "", //基地地址
        baseWebsite: "", //基地网址
        baseOpenServiceHours: "", //基地开放服务时间
        trafficRoutes: "", //交通路线
        vrWebsite: "", //VR虚拟场馆网址（可填）
        baseIntroduction: "", //基地简介
        activityIntroduction: '',//活动介绍
      },
      baseImgFileList: [],//基地图片列表
      actImgFileList: [],//活动图片列表

      baseVideoUrl: [],//基地视频列表
      actVideoUrl: [],//活动视频列表

    };
  },
  methods: {
    beforeUploadOfImg(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('请上传jpg/png格式图片!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isLt2M) {
        this.$message.error('图片必须大于2MB!');
      }
      return isJpgOrPng && !isLt2M;
    },
    //图片上传
    // handleChangeOfImg({ fileList }) {
    //   console.log(fileList);
    // },
    uploadImgFun(option, _flag) {
      console.log(option.file);
      console.log(_flag);
      this.baseImgSpinning = _flag == 1
      this.actImgSpinning = _flag == 2
      var form = new FormData();
      form.append("multipartFile", option.file);
      openUploadApi(form).then((res) => {
        if (res.status) {
          if (_flag == 1) {
            this.baseImgSpinning = false
            this.baseImgFileList.push({
              uid: Date.now(),
              name: 'image.png',
              status: 'done',
              url: res.data
            })
            console.log(this.baseImgFileList);
          } else if (_flag == 2) {
            this.actImgSpinning = false
            this.actImgFileList.push({
              uid: Date.now(),
              name: 'image.png',
              status: 'done',
              url: res.data
            })
            console.log(this.actImgFileList);
          }

        }
      }).catch(() => { })
    },
    // 删除图片
    imgDel(file, _flag) {
      if (_flag == 1) {
        var index = this.baseImgFileList.indexOf(file)
        this.baseImgFileList.splice(index, 1)
      } else if (_flag == 2) {
        var index = this.actImgFileList.indexOf(file)
        this.actImgFileList.splice(index, 1)
      }
    },

    //视频上传
    beforeUploadOfVideo(file) {
      const isMp4OrPng = file.type === 'video/mp4';
      if (!isMp4OrPng) {
        this.$message.error('请上传mp4格式图片!');
      }
      const isLt200M = file.size / 1024 / 1024 < 200;
      if (!isLt200M) {
        this.$message.error('视频必须小于200MB!');
      }
      return isMp4OrPng && isLt200M;
    },
    uploadVideoFun(option, _flag) {
      this.baseVideoSpinning = _flag == 1
      this.actVideoSpinning = _flag == 2
      let form = new FormData();
      form.append("multipartFile", option.file);
      openSplitUploadApi(form).then((res) => {
        if (res.status) {
          if (_flag == 1) {
            this.baseVideoSpinning = false
            this.baseVideoUrl.push(res.data)
          } else if (_flag == 2) {
            this.actVideoSpinning = false
            this.actVideoUrl.push(res.data)
          }
        }
      }).catch(() => { })
    },
    removeVideo(index, _flag) {
      if (_flag == 1) {
        this.baseVideoUrl.splice(index, 1)
      } else if (_flag == 2) {
        this.actVideoUrl.splice(index, 1)
      }
    },
    //非空验证
    checkForm() {
      for (var key in this.dataInfo) {
        if (!this.dataInfo[key] && (key != 'baseWebsite' && key != 'vrWebsite')) {
          this.$message.warn('请将必填项补充完整!')
          return false
        };
      }
      if (this.dataInfo.baseIntroduction.length > 450) {
        this.$message.warn('基地简介在450字以内!')
        return false
      } else if (this.dataInfo.activityIntroduction.length > 450) {
        this.$message.warn('活动介绍在450字以内!')
        return false
      } else if (this.baseImgFileList.length < 3) {
        this.$message.warn('请上传至少三张基地照片!')
        return false
      } else if (this.actImgFileList.length < 3) {
        this.$message.warn('请上传至少三张特色普及活动照片!')
        return false
      } else if (this.baseVideoUrl.length == 0) {
        this.$message.warn('请上传基地宣传视频!')
        return false
      } else if (this.actVideoUrl.length == 0) {
        this.$message.warn('请上传特色活动视频!')
        return false
      } else {
        return true
      }
    },
    //宣传申报
    createPublicizeFun(_status) {
      if (!this.checkForm()) return
      let obj = JSON.parse(localStorage.getItem("userModel"));
      this.dataInfo.baseImgList = JSON.stringify(this.baseImgFileList)
      this.dataInfo.actImgList = JSON.stringify(this.actImgFileList)
      this.dataInfo.baseVideoList = JSON.stringify(this.baseVideoUrl)
      this.dataInfo.actVideoList = JSON.stringify(this.actVideoUrl)
      console.log(this.dataInfo);
      let params = {
        baseName: this.dataInfo.baseName,//基地名称
        linkMan: this.dataInfo.responsor,//基地负责人
        linkPhone: this.dataInfo.responsorPhone,//基地负责人联系方式
        extraInfo: JSON.stringify(this.dataInfo),//表单数据
        type: 3,//申报类型
        fromSource: obj.userType,
        status: _status,
        toTarget: obj.userType,
      };
      if (this.declareId == '') {
        //新增
        params.createUid = obj.productUserId
        params.decEntrance = obj.decEntrance//申报入口
        if (obj.decEntrance == '部属、省属高校') {
          params.secondaryDecEntrance = obj.secondaryDecEntrance ? obj.secondaryDecEntrance : obj.productUserId
        };
        createdecInformationApi(params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              this.$emit("backProject");
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        //修改
        params.id = this.declareId
        updateDecInformationApi(params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              this.$emit("backProject");
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    //返回
    cancel() {
      this.$emit("backProject");
    },
  },
  created() {
    if (localStorage.getItem("userModel")) {
      let obj = JSON.parse(localStorage.getItem("userModel"));
      this.userId = obj.productUserId
      console.log(obj.decEntrance);
      this.dataInfo.decEntrance = obj.decEntrance;
      console.log(this.dataInfo.decEntrance);
      // this.dataInfo.unitName = obj.unitName;
      this.userTypeValue = JSON.parse(
        localStorage.getItem("userModel")
      ).userType;
    }
    if (!sessionStorage.getItem("declareInfo")) {
      for (var key in this.dataInfo && key != 'decEntrance') {
        this.dataInfo[key] = ''
      }
      this.baseImgFileList = []
      this.actImgFileList = []
      this.baseVideoUrl = []//基地视频列表
      this.actVideoUrl = []//活动视频列表
    } else {
      let details = JSON.parse(sessionStorage.getItem("declareInfo"))
      this.declareId = details.id
      this.createUid = details.createUid
      let _info = JSON.parse(details.extraInfo)
      this.dataInfo = _info
      console.log(this.dataInfo);
      this.baseImgFileList = JSON.parse(_info.baseImgList)
      console.log(this.baseImgFileList);
      this.actImgFileList = JSON.parse(_info.actImgList)
      console.log(this.actImgFileList);
      this.baseVideoUrl = JSON.parse(_info.baseVideoList)
      this.actVideoUrl = JSON.parse(_info.actVideoList)

    }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
